import { Provider } from "components/nation/NationContext";
import { NationList } from "components/nation/NationList";
import React from 'react';

export const Nations = () => {
    return (
        <Provider>
            <NationList />
        </Provider>
    );
};
